import AvailabilityCharts from './AvailabilityCharts';

export default AvailabilityCharts;
